import React, { useEffect } from 'react';
import StickyHeader from '../../components/ui/StickyHeader';
import FloatingCTA from '../../components/ui/FloatingCTA';
import ProgressIndicator from '../../components/ui/ProgressIndicator';
import QuickNavDots from '../../components/ui/QuickNavDots';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import FeaturesSection from './components/FeaturesSection';
import AIVictoriaSection from './components/AIVictoriaSection';
import CustomSolutionsSection from './components/CustomSolutionsSection';
import SocialProofSection from './components/SocialProofSection';
import ROICalculatorSection from './components/ROICalculatorSection';
import PricingSection from './components/PricingSection';
import FAQSection from './components/FAQSection';
import DemoSection from './components/DemoSection';
import FooterSection from './components/FooterSection';

const LandingPage = () => {
  useEffect(() => {
    document.title = 'СФЕРА CRM - Единая платформа нового поколения с ИИ-автоматизацией';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription?.setAttribute('content', 'Трансформируйте ваш бизнес с СФЕРА - единственной CRM-платформой, объединяющей AI-автоматизацию, темный glass-интерфейс и полную кастомизацию бизнес-процессов');
    }
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <StickyHeader />
      <FloatingCTA />
      <ProgressIndicator />
      <QuickNavDots />
      
      <main>
        <HeroSection />
        <ProblemSection />
        <FeaturesSection />
        <AIVictoriaSection />
        <CustomSolutionsSection />
        <SocialProofSection />
        <ROICalculatorSection />
        <PricingSection />
        <FAQSection />
        <DemoSection />
      </main>

      <FooterSection />
    </div>
  );
};

export default LandingPage;